export default "__VITE_ASSET__BwCOj3GX__"